<script>
export default {
    name: "SynchronizationMixin",
    methods: {
        synchronizationIcon(synchronization) {
            if (!synchronization || !synchronization.status) {
                return "mdi-clock-outline"
            }
            switch (synchronization.status) {
                case "waiting":
                    return "mdi-clock-outline";
                case "synchronizing":
                    return "mdi-sync";
                case "success":
                    return "mdi-check-circle-outline";
                case "error":
                    return "mdi-alert-outline";
                default:
                    return "mdi-clock-outline"
            }
        }
    }
}
</script>
